<template>
  <div class="login-page">
    <div class="wrapper wrapper-full-page">
      <div class="full-page section-image">
        <el-row justify="center" align="middle" class="login-frame">
          <el-col :md="8" :xs="24">
            <!-- Step 3: the user picks which factor to use -->
            <el-form v-if="stage === 'select'" :class="shakeClass">
              <el-card class="login-card" style="color: rgb(250, 250, 250)">
                <div class="logo">
                  <img
                    src="~img/logo/ss-logo-8-12-2021.svg"
                    alt="SendSquared"
                  />
                </div>
                <h3 class="mfa-heading">Verify It's You</h3>
                <p>
                  MFA is enabled on this account. <br /><br />Choose how you
                  would like to get your code.
                </p>
                <br />

                <el-row v-if="mfaError">
                  <el-col :span="24" align="center">
                    <el-tag
                      closable
                      @close="mfaError = ''"
                      type="danger"
                      style="margin-bottom: 10px"
                      >{{ mfaError }}</el-tag
                    >
                  </el-col>
                </el-row>
                <el-row v-for="option in mfaOptions" :key="option.method">
                  <el-col :span="24">
                    <el-button
                      class="mfa-option"
                      :disabled="startingMfa"
                      @click.prevent="startMfa(option.method)"
                    >
                      <div class="mfa-option-label">
                        {{ mfaOptionLabel(option) }}
                      </div>
                      <div class="mfa-option-detail">
                        {{ mfaOptionDetail(option) }}
                      </div>
                    </el-button>
                  </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                  <el-col :span="24" align="center">
                    <el-button
                      @click="restartLogin"
                      link
                      style="
                        color: rgb(250, 250, 250);
                        text-decoration: underline;
                      "
                      >Back to login</el-button
                    >
                  </el-col>
                </el-row>
              </el-card>
            </el-form>
            <!-- Step 5: exchange the code for a session -->
            <el-form v-if="stage === 'code'" :class="shakeClass">
              <el-card class="login-card" style="color: rgb(250, 250, 250)">
                <div class="logo">
                  <img
                    src="~img/logo/ss-logo-8-12-2021.svg"
                    alt="SendSquared"
                  />
                </div>
                <h3 class="mfa-heading">MFA Required</h3>
                <p>{{ mfaPrompt }}</p>
                <br /><br />

                <el-row v-if="mfaError">
                  <el-col :span="24" align="center">
                    <el-tag
                      closable
                      @close="mfaError = ''"
                      type="danger"
                      style="margin-bottom: 10px"
                      >{{ mfaError }}</el-tag
                    >
                  </el-col>
                </el-row>
                <el-row>
                  <el-input
                    v-model="otp"
                    type="text"
                    name="otp"
                    maxlength="6"
                    required
                  />
                </el-row>
                <el-row>
                  <el-checkbox v-model="mfaTrust">
                    Trust this device for 30 days</el-checkbox
                  >
                </el-row>
                <!-- Nothing was delivered for totp, so there is nothing to resend -->
                <el-row v-if="canResendMfa">
                  <el-col :span="12" style="color: rgb(250, 250, 250)">
                    I did not receive my code.
                    <el-button
                      @click="resendMfa"
                      link
                      style="
                        color: rgb(250, 250, 250);
                        text-decoration: underline;
                      "
                      >Resend.</el-button
                    >
                  </el-col>
                </el-row>
                <!-- A session can only start one challenge, so a different
                     factor means starting the login over -->
                <el-row v-if="mfaOptions.length > 1">
                  <el-col :span="24" style="color: rgb(250, 250, 250)">
                    Need a different method?
                    <el-button
                      @click="restartLogin"
                      link
                      style="
                        color: rgb(250, 250, 250);
                        text-decoration: underline;
                      "
                      >Start over.</el-button
                    >
                  </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                  <el-col :span="24" align="center">
                    <el-button
                      type="primary"
                      size="large"
                      native-type="submit"
                      :disabled="verifyingMfa"
                      @click.prevent="verifyOtp"
                      >Verify Code</el-button
                    >
                  </el-col>
                </el-row>
              </el-card>
            </el-form>
            <el-form
              v-if="stage === 'password'"
              @submit.prevent="loginUser"
              :label-position="'left'"
              :class="shakeClass"
            >
              <el-card class="login-card">
                <div class="logo">
                  <img
                    src="~img/logo/ss-logo-8-12-2021.svg"
                    alt="SendSquared"
                  />
                </div>

                <el-row v-if="form.status">
                  <el-col :span="24" align="center">
                    <el-tag
                      closable
                      @close="form.status = ''"
                      type="danger"
                      style="margin-bottom: 10px"
                      >{{ form.status }}</el-tag
                    >
                  </el-col>
                </el-row>

                <el-form-item label="">
                  <el-input
                    v-model="form.username"
                    placeholder="Enter your email address"
                    autocomplete="username"
                    size="large"
                    class="login-form-input"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.password"
                    placeholder="Password"
                    autocomplete="current-password"
                    size="large"
                    :type="formElements.passwordType"
                    :show-password="formElements.passwordType === 'password'"
                    @click:append="changePasswordType"
                    class="login-form-input"
                  ></el-input
                ></el-form-item>

                <el-row>
                  <el-col :span="12">
                    <router-link
                      to="/forgotten"
                      style="color: rgb(250, 250, 250)"
                      >Forgot Password?</router-link
                    >
                  </el-col>
                  <el-col :span="12" align="right">
                    <el-link
                      href="https://sendsquared.com"
                      style="color: rgb(250, 250, 250)"
                      >Website</el-link
                    >
                  </el-col>
                </el-row>

                <el-divider></el-divider>

                <el-row>
                  <el-col :span="24" align="center">
                    <el-button
                      type="primary"
                      size="large"
                      native-type="submit"
                      :disabled="loggingIn"
                    >
                      {{ loggingIn ? 'Please wait' : 'Login' }}
                    </el-button>
                  </el-col></el-row
                >
              </el-card>
            </el-form>
          </el-col>
        </el-row>
        <app-footer></app-footer>
        <div
          class="full-page-background color-yellow"
          :style="getBackground"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';

import AppFooter from './Layout/AppFooter';
import ConfigService from '/src/services/configService';

import { publicAxios } from 'src/shared/axiosWrapper';

export default {
  computed: {
    ...mapState({
      account: (state) => state.auth.authAccount,
    }),
    getBackground() {
      const number = Math.floor(Math.random() * 4 + 1);
      return `background-image: url('https://static.sendsquared.com/images/oct-2021-background-${number}.jpg');`;
    },
    mfaPrompt() {
      switch (this.mfaMethod) {
        case 'sms':
          return `We sent a code to the phone ending in ${this.mfaContext}.`;
        case 'email':
          return `We sent a code to ${this.mfaContext}.`;
        case 'totp':
          return `Enter the current code from your authenticator app${
            this.mfaContext ? ` (${this.mfaContext})` : ''
          }.`;
        default:
          return 'Please enter your verification code to continue.';
      }
    },
    // The API has nothing to resend for an authenticator app, so it 409s
    canResendMfa() {
      return this.mfaMethod !== 'totp';
    },
  },
  components: {
    AppFooter,
  },
  methods: {
    ...mapActions('auth', ['processLogin']),
    async verifyOtp() {
      this.loadingScreen(true);
      this.verifyingMfa = true;
      if (!this.otp) {
        this.loadingScreen(false);
        this.verifyingMfa = false;
        return false;
      }
      let otpResult;
      try {
        otpResult = await publicAxios.post('/v1/login/otp', {
          otp: this.otp,
          // The challenge id from mfa-start, not the session id from /login
          id: this.mfaChallengeId,
          full_acls: true,
          trust: this.mfaTrust,
        });
      } catch (e) {
        this.loadingScreen(false);
        this.verifyingMfa = false;
        this.shakeForm();
        this.mfaError = e.response.data;
        return false;
      }
      await this.processLogin(otpResult.data);
      await ConfigService.loadConfig();
      await this.$router.push('/admin/overview');
      this.loadingScreen(false);
    },
    async resendMfa() {
      this.$confirm(
        'A new code will be sent. The old code will be invalidated. Proceed?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      ).then(async () => {
        let resend;
        try {
          // Trigger new mfa resend; channel will determine what that means;
          // Currently only OTP but others in time
          resend = await publicAxios.post('/v1/login/mfa-resend', {
            // Resends on the factor the user picked, so this takes the
            // challenge id rather than the session id
            id: this.mfaChallengeId,
          });
        } catch (e) {
          this.$message({
            message: 'Error Resending Code: ' + (e.response?.data ?? e),
            type: 'error',
            showClose: true,
          });
          return false;
        }
        this.$message({
          message: 'Code has been regenerated and will be resent shortly',
          type: 'success',
          showClose: true,
        });
        // Reset the MFA bits for the new code
        this.mfaMethod = resend.data.mfa_required.method;
        this.mfaChallengeId = resend.data.mfa_required.id;
        this.mfaContext = resend.data.mfa_required.context;
      });
    },
    mfaOptionLabel(option) {
      switch (option.method) {
        case 'totp':
          return 'Authenticator app';
        case 'sms':
          return 'Text message';
        case 'email':
          return 'Email';
        default:
          return option.method;
      }
    },
    mfaOptionDetail(option) {
      switch (option.method) {
        case 'sms':
          return `Phone ending in ${option.context}`;
        // totp is the device name, email is a masked address
        default:
          return option.context;
      }
    },
    // Opens the challenge for the one factor the user picked. Also called for
    // totp, where nothing is delivered but the challenge still has to exist.
    async startMfa(method) {
      this.loadingScreen(true);
      this.startingMfa = true;
      this.mfaError = undefined;
      let startResult;
      try {
        startResult = await publicAxios.post('/v1/login/mfa-start', {
          id: this.mfaSessionId,
          method,
        });
      } catch (e) {
        this.startingMfa = false;
        this.loadingScreen(false);
        this.shakeForm();
        // The session id is spent, expired, or the account hit the max
        // Not recoverable so error and send them back
        this.restartLogin();
        this.form.status =
          e.response?.data ?? 'Unable to send a code. Please try again.';
        return false;
      }
      this.mfaMethod = startResult.data.mfa_required.method;
      this.mfaChallengeId = startResult.data.mfa_required.id;
      this.mfaContext = startResult.data.mfa_required.context;
      this.otp = undefined;
      this.startingMfa = false;
      this.stage = 'code';
      this.loadingScreen(false);
    },
    // A session id can only ever start one challenge
    // picikng a different factor means going through /v1/login again.
    restartLogin() {
      this.stage = 'password';
      this.form.password = '';
      this.form.status = '';
      this.otp = undefined;
      this.mfaSessionId = undefined;
      this.mfaOptions = [];
      this.mfaChallengeId = undefined;
      this.mfaMethod = undefined;
      this.mfaContext = undefined;
      this.mfaTrust = false;
      this.mfaError = undefined;
      this.startingMfa = false;
      this.verifyingMfa = false;
      this.addLoginClass();
    },
    async loginUser() {
      this.loadingScreen(true);
      if (!this.form.username || !this.form.password) {
        this.loadingScreen(false);
        return false;
      }
      // Check to see if we have a trusted id and pass that along
      let loginResult;
      try {
        loginResult = await publicAxios.post('/v1/login', {
          username: this.form.username,
          password: this.form.password,
          full_acls: true,
          device_id: localStorage.getItem('s2-trusted-device') ?? undefined,
        });
      } catch (e) {
        if (e.response) {
          // TODO: we should be passing more specific error messages from the API
          const status = {
            422: 'Invalid input. Confirm this is a valid email address',
            403: 'username/password do not match',
            401: e.response.data ?? 'Username/password are not valid',
            409: e.response.data ?? 'Unknown error logging in',
          };
          this.form.status =
            status[e.response.status] ||
            e.response.data?.error ||
            'Unexpected Authorization Error. Please try back later';
          console.error(e.response);
        } else {
          this.form.status =
            'Unexpected System Error logging in. Please try again later';
          console.error(e);
        }
        this.shakeForm();
        this.loadingScreen(false);
        return false;
      }

      if (loginResult.data.mfa_options) {
        // Clear existing, if any, and we will add new
        localStorage.removeItem('s2-trusted-device');
        this.mfaSessionId = loginResult.data.mfa_options.id;
        this.mfaOptions = loginResult.data.mfa_options.options ?? [];

        if (!this.mfaOptions.length) {
          this.loadingScreen(false);
          this.shakeForm();
          this.form.status =
            'MFA is required on this account but no method is available. Please contact your administrator.';
          return false;
        }

        this.removeLoginClass();

        // Nothing to choose between, so skip the picker
        if (this.mfaOptions.length === 1) {
          return this.startMfa(this.mfaOptions[0].method);
        }

        this.loadingScreen(false);
        this.stage = 'select';
        return;
      } else {
        // Login as normal
        await this.processLogin(loginResult.data);
        await ConfigService.loadConfig();
        this.$router.push('/admin/overview');
        this.loadingScreen(false);
      }
    },
    changePasswordType() {
      if (this.formElements.passwordType == 'password') {
        this.formElements.passwordType = 'text';
        this.formElements.passwordIcon = 'el-icon-lock';
      } else {
        this.formElements.passwordType = 'password';
        this.formElements.passwordIcon = 'el-icon-view';
      }
    },
    shakeForm() {
      this.shakeClass = 'ahashakeheartache';
      setTimeout(() => {
        this.shakeClass = '';
      }, 800);
    },
    loadingScreen(active) {
      if (active) {
        // Onnly one overlay at a time
        if (this.loading) {
          this.loading.close();
        }
        this.loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)',
        });
      } else if (this.loading) {
        this.loading.close();
        this.loading = undefined;
      }
      this.loggingIn = active;
    },
    addLoginClass() {
      document.body.classList.add('drop-margin');
    },
    removeLoginClass() {
      document.body.classList.remove('drop-margin');
    },
  },
  created() {
    this.addLoginClass();
  },
  data() {
    return {
      shakeClass: '',
      form: {
        username: '',
        password: '',
        status: '',
      },
      formElements: {
        passwordType: 'password',
        passwordIcon: 'el-icon-view',
      },
      loading: undefined,
      loggingIn: false,
      // 'password' -> 'select' -> 'code'; 'select' is skipped when the user
      // only has one factor turned on
      stage: 'password',
      // MFA bits
      otp: undefined,
      // Proves the password cleared; starts exactly one challenge
      mfaSessionId: undefined,
      mfaOptions: [],
      // Identifies the challenge; what /otp and mfa-resend take
      mfaChallengeId: undefined,
      mfaMethod: undefined,
      mfaContext: undefined,
      mfaTrust: false,
      startingMfa: false,
      verifyingMfa: false,
      mfaError: undefined,
    };
  },
};
</script>
<style lang="scss" scoped>
.logo {
  text-align: center;

  img {
    // width: 75%;
    margin: 0 auto;
    margin-bottom: 2em;
  }
}

.full-page-background {
  position: absolute;
  z-index: 1;
  height: 100vh;
  width: 100vw;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
}

.login-frame {
  z-index: 4;
  height: 90vh;
}

.login-card {
  background-color: rgba(37, 36, 34, 0.85);
  border-color: rgba(37, 36, 34, 0.95);
}

.logo img {
  width: 230px;
  margin-top: 1em;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.mfa-heading {
  color: rgb(250, 250, 250);
  text-align: center;
  border-top: 2px solid white;
}

// These sit on a dark card, so the light default button palette leaves the
// label unreadable until hover recolours it. Drive every state off Element's
// own variables rather than inheriting whatever the card cascades down.
.mfa-option {
  --el-button-text-color: rgb(250, 250, 250);
  --el-button-bg-color: rgba(255, 255, 255, 0.08);
  --el-button-border-color: rgba(250, 250, 250, 0.35);
  --el-button-hover-text-color: rgb(255, 255, 255);
  --el-button-hover-bg-color: rgba(255, 255, 255, 0.18);
  --el-button-hover-border-color: rgba(250, 250, 250, 0.7);
  --el-button-active-text-color: rgb(255, 255, 255);
  --el-button-active-bg-color: rgba(255, 255, 255, 0.24);
  --el-button-active-border-color: rgba(250, 250, 250, 0.8);
  --el-button-disabled-text-color: rgba(250, 250, 250, 0.45);
  --el-button-disabled-bg-color: rgba(255, 255, 255, 0.04);
  --el-button-disabled-border-color: rgba(250, 250, 250, 0.2);

  width: 100%;
  height: auto;
  min-height: 52px;
  margin: 0 0 10px;
  padding: 10px 16px;
  white-space: normal;
}

// el-button centers its slot in an inline-flex span; stack it left instead
.mfa-option :deep(span) {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  text-align: left;
}

.mfa-option-label {
  font-weight: 600;
}

.mfa-option-detail {
  font-size: 12px;
  line-height: 1.3;
  opacity: 0.75;
}

.status {
  color: red;
  text-align: center;
}
.el-input__inner {
  color: #222222;
}

.ahashakeheartache {
  animation: kf_shake 0.4s 1 linear;
}

@keyframes kf_shake {
  0% {
    transform: translate(30px);
  }

  20% {
    transform: translate(-30px);
  }

  40% {
    transform: translate(15px);
  }

  60% {
    transform: translate(-15px);
  }

  80% {
    transform: translate(8px);
  }

  100% {
    transform: translate(0px);
  }
}
</style>
